import { createContext, FC, useCallback, useContext, useState } from 'react';
import useCollapsableSidebarState from '@app/core/hooks/useLocalStoreSidebarCollapse';

interface BuildStructureContextValue {
  newlyCreatedEventId: string | undefined;
  setNewlyCreatedEventId: (eventId: string | undefined) => void;
  expandSidebar: () => void;
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

const BuildStructureContext = createContext<BuildStructureContextValue | undefined>(undefined);

export const BuildStructureProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [newlyCreatedEventId, setNewlyCreatedEventIdState] = useState<string | undefined>(
    undefined
  );
  const [isSidebarCollapsed, toggleSidebar, expandSidebar] = useCollapsableSidebarState(
    'collapsed-capital-structure-sidebar'
  );

  const setNewlyCreatedEventId = useCallback((eventId: string | undefined) => {
    setNewlyCreatedEventIdState(eventId);
  }, []);

  return (
    <BuildStructureContext.Provider
      value={{
        newlyCreatedEventId,
        setNewlyCreatedEventId,
        expandSidebar,
        isSidebarCollapsed,
        toggleSidebar,
      }}>
      {children}
    </BuildStructureContext.Provider>
  );
};

export const useBuildStructureContext = (): BuildStructureContextValue => {
  const context = useContext(BuildStructureContext);
  if (!context) {
    throw new Error('useBuildStructureContext must be used within a BuildStructureProvider');
  }
  return context;
};
